export default {
  sort_by: 'Sortieren nach',
};
